import PropTypes from "prop-types";
import React from "react";
import MerchandisingListing from "app/pages/Merchandising/MerchandisingListing";
import { forceCheck } from "react-lazyload";
import { withRouter } from "react-router-dom";
import { acceptCookyPolicy } from "app/pages/.shared/CookiePolicyFooter/cookiePolicyActionCreators";
import { clearProduct, fetchProducts } from "app/pages/Listing/productActionCreators";
import {
	getMerchandisingMedias,
	getMerchandisingTopicsFilterValuesFromMerchCode,
	getVisibleProductsOfMerchandising,
} from "app/pages/Merchandising/merchandisingSelector";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import get from "lodash/get";
import { sendTagOnMerchandisingListingLoad } from "app/utils/analytics";
import RequireSignupFirst from "app/pages/Auth/RequireSignupFirst";
import { fetchMerchandising } from "app/pages/Merchandising/merchandisingActionCreators";
import { parseQueries } from "app/utils/routerUtils";
import { getFallbackRedirectUrl } from "app/reducers/partnerSelector";

class MerchandisingContainer extends React.Component {
	componentWillUnmount() {
		// La navigation sur le site vaut acceptation des cookies
		this.props.acceptCookyPolicy();
	}

	componentDidMount() {
		const { history, fetchMerchandising } = this.props;

		const queries = parseQueries(history.location.search);

		fetchMerchandising({
			code: queries.code,
		}).then(response => {
			const merchandising = get(response, "data.merchandising", {});
			const products = get(response, "data.products", []);
			sendTagOnMerchandisingListingLoad(
				merchandising.code,
				merchandising.label,
				merchandising.position,
				merchandising.headerIndex,
				products.slice(0, 3)
			);
			forceCheck();
		});
	}

	render() {
		return (
			<RequireSignupFirst
				{...this.props}
				renderComponent={props => {
					return <MerchandisingListing {...props} />;
				}}
			/>
		);
	}
}

MerchandisingContainer.propTypes = {
	history: PropTypes.object,
	route: PropTypes.object,
	fetchProducts: PropTypes.func,
	clearProduct: PropTypes.func,
	acceptCookyPolicy: PropTypes.func,
	partnerCode: PropTypes.string,
	resolution: PropTypes.string,
	fetchMerchandising: PropTypes.func,
};

const mapStateToProps = state => {
	return {
		activeFilter: state.merchandising.activeFilter,
		resolution: state.resolution,
		partnerCode: state.partner.code,
		merchandisingMedias: getMerchandisingMedias(state),
		currentMerchandising: state.merchandising.current,
		productsOfMerchandising: getVisibleProductsOfMerchandising(state),
		merchandisings: state.merchandising.lightList,
		merchandisingTopics: getMerchandisingTopicsFilterValuesFromMerchCode(state),
		fallbackRedirectUrl: getFallbackRedirectUrl(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchProducts,
			clearProduct,
			acceptCookyPolicy,
			fetchMerchandising,
		},
		dispatch
	);
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(MerchandisingContainer)
);
